import PropTypes from "prop-types"
import React from "react"

import InstantGiftExplained from "areas/instant-gift/explained"
import Modal from "components/modal"

const InstantGiftPreview = ({ inCart }) => (
  <Modal
    contentStyle={{ pt: { _: "10px", tablet: 0 } }}
    headerStyle={{ mb: { _: "12px", tablet: "10px" } }}
    label="How Gift Preview Video Works"
    show="#gift-preview-video-explained"
    variant="squircle"
    width="800px"
  >
    <InstantGiftExplained inCart={inCart} inModal />
  </Modal>
)

InstantGiftPreview.propTypes = {
  inCart: PropTypes.bool,
}

export default InstantGiftPreview
